import { Link } from "react-router-dom";
import Reveal from "./Reveal";

export default function Manifesto() {
  return (
    <section className="relative bg-paper text-[var(--ink)] py-24 md:py-40 px-5 md:px-10 overflow-hidden">
      {/* Subtle paper texture */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04] bg-noise" />

      <div className="relative max-w-7xl mx-auto grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-3">
          <Reveal>
            <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay-deep)]">
              — Manifesto
            </div>
            <div className="mt-3 font-display text-5xl md:text-7xl text-[var(--ink)]">
              01
            </div>
          </Reveal>
        </div>

        <div className="col-span-12 md:col-span-9">
          <Reveal delay={120}>
            <h2 className="font-display font-light text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight">
              A wall is never just a wall. It is a{" "}
              <span className="italic font-extralight">public</span> memory, a{" "}
              <span className="italic font-extralight">shared</span> sentence,
              a quiet <span className="italic font-extralight">protest</span>.
            </h2>
          </Reveal>

          <Reveal delay={240}>
            <div className="mt-12 grid md:grid-cols-2 gap-8 md:gap-16 text-[var(--ink)]/80 text-[17px] leading-relaxed">
              <p>
                We are a Delhi-based mural art studio. We believe a hand-painted
                wall carries what no screen can — the warmth of a brushstroke,
                the memory of a place, the dignity of a face remembered. Our
                practice is rooted in India and reaching outward.
              </p>
              <p>
                Every mural we paint is a slow conversation with the space and
                the people who live in it. We don't decorate walls. We give
                them a voice — and then we let them speak for years to come.
              </p>
            </div>
          </Reveal>

          <Reveal delay={360}>
            <div className="mt-12 flex flex-wrap items-center gap-4">
              <Link
                to="/about"
                className="group inline-flex items-center gap-3 px-6 py-3.5 bg-[var(--ink)] text-[var(--bone)] rounded-full text-sm tracking-wide hover:bg-[var(--clay)] transition-colors"
              >
                Read our story
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </Link>
              <span className="text-xs uppercase tracking-[0.28em] text-[var(--ink)]/60">
                Vikas Mandal & Mohammed Zaid · Co-founders
              </span>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Signature */}
      <Reveal delay={500}>
        <div className="relative max-w-7xl mx-auto mt-24 pt-12 border-t border-[var(--ink)]/10 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <div className="font-display italic text-2xl text-[var(--ink)]">
              — painted by hand,
            </div>
            <div className="font-display italic text-2xl text-[var(--clay)]">
              signed by place.
            </div>
          </div>
          <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--ink)]/50">
            TABA Studio Practice · Since 2018
          </div>
        </div>
      </Reveal>
    </section>
  );
}